import { CloseOutlined } from "@ant-design/icons";
import React, { useEffect, useRef, useState } from "react";
import { useLockFn, useScroll, useUpdateEffect } from "ahooks";
import { Link } from "react-router-dom";
import general from "../../general";
import $ from "jquery";
import Dialog from "../../lib/Dialog";
import Image from "../../lib/Image";
import useUrlState from "@ahooksjs/use-url-state";

const sorts = [
  {
    sort: "xh_login_time",
    text: "最近在玩",
  },
  {
    sort: "hot_trade",
    text: "热门交易",
  },
  {
    sort: "publish",
    text: "最新发布",
  },
  {
    sort: "effective",
    text: "性价比最高",
  },
  {
    sort: "asc",
    text: "价格升序",
  },
  {
    sort: "desc",
    text: "价格降序",
  },
];

const devices = [
  {
    device: 0,
    text: "双端",
  },
  {
    device: 1,
    text: "安卓",
  },
  {
    device: 2,
    text: "苹果",
  },
];

const initFilter = {
  sort: 0,
  type: null,
  device: null,
  minPrice: undefined,
  maxPrice: undefined,
};

// FilterContent 组件：用于在 Dialog 中显示筛选内容
const FilterContent = ({ initialFilter, onConfirm }) => {
  const [localFilter, setLocalFilter] = useState(initialFilter);

  const handlePriceChange = (field, value) => {
    setLocalFilter({ ...localFilter, [field]: value });
  };

  const handleConfirm = () => {
    if (localFilter.minPrice && localFilter.minPrice < 1) {
      Dialog.error("最低价格最少1元");
      return;
    }

    if (
      localFilter.minPrice &&
      localFilter.maxPrice &&
      localFilter.minPrice > localFilter.maxPrice
    ) {
      Dialog.error("最低价格需小于最高价格");
      return;
    }

    Dialog.close();
    document.body.style.overflow = "auto";
    onConfirm(localFilter);
  };

  return (
    <div className="trade-filter">
      <div className="container">
        <div className="title" style={{ marginTop: "3px" }}>
          排序方式
        </div>
        <div className="type">
          {sorts.map((item, index) => (
            <div
              key={index}
              className={"item" + (index === localFilter.sort ? " active" : "")}
              onClick={() => setLocalFilter({ ...localFilter, sort: index })}
            >
              {item.text}
            </div>
          ))}
        </div>

        <div className="title" style={{ marginTop: "16px" }}>
          设备
        </div>
        <div className="type">
          {devices.map((item, index) => (
            <div
              key={index}
              className={
                "item" + (index === localFilter.device ? " active" : "")
              }
              onClick={() => {
                console.log("index", index);
                setLocalFilter({ ...localFilter, device: index });
              }}
            >
              {item.text}
            </div>
          ))}
        </div>

        <div className="title" style={{ marginTop: "16px" }}>
          价格区间
        </div>
        <div className="prices">
          <input
            type="number"
            placeholder="最低价"
            value={localFilter.minPrice || ""}
            onChange={(e) => {
              let value = e.target.value;
              // 移除所有非数字字符
              let numValue = value.replace(/[^\d]/g, "");
              // 如果处理后的值不为空，设置为该值
              if (numValue !== "") {
                handlePriceChange("minPrice", Number(numValue));
              } else {
                handlePriceChange("minPrice", 0);
              }
            }}
          />
          <div className="price-line"></div>
          <input
            type="number"
            placeholder="最高价"
            maxLength={8}
            value={localFilter.maxPrice || ""}
            onChange={(e) => {
              let value = e.target.value;
              // 移除所有非数字字符
              let numValue = value.replace(/[^\d]/g, "");
              // 如果处理后的值不为空，设置为该值
              if (numValue !== "") {
                handlePriceChange("maxPrice", Number(numValue));
              } else {
                handlePriceChange("maxPrice", 0);
              }
            }}
          />
        </div>

        <div className="operate">
          <div className="reset" onClick={() => setLocalFilter(initFilter)}>
            重置
          </div>
          <div className="confirm" onClick={handleConfirm}>
            确定
          </div>
        </div>
      </div>
    </div>
  );
};

export default (props) => {
  const [filter, setFilter] = useState(initFilter);
  const [query, setQuery] = useUrlState({ keyword: "" });

  const [kw, setKw] = useState("");
  const sortRef = useRef(null);

  // 同步 props.keyword 的变化
  useEffect(() => {
    if (props.keyword !== undefined) {
      setKw(props.keyword);
    }
  }, [props.keyword]);

  const [page, setPage] = useState(1);
  const [trades, setTrades] = useState([]);
  const [more, setMore] = useState(true);
  const [init, setInit] = useState(false);

  // load 函数接收参数，避免闭包问题
  const load = useLockFn(async (parms = {}) => {
    // 使用传入的参数或当前状态
    const currentFilter = parms.filter !== undefined ? parms.filter : filter;
    const currentKw = parms.kw !== undefined ? parms.kw : kw;

    console.log("filter", currentFilter);

    Dialog.loading();
    let data = {
      apply_type: 1,
      sort_type: sorts[currentFilter.sort].sort,
      game_device_type:
        currentFilter.device !== null
          ? devices[currentFilter.device].device
          : "",
      type: props.type,
      game_name: currentKw,
      pagination: { count: 20, page },
    };
    if (currentFilter.minPrice && currentFilter.maxPrice) {
      data.trade_price_range =
        currentFilter.minPrice + "-" + currentFilter.maxPrice;
    }

    if (parms.page) {
      data.pagination.page = parms.page;
    }
    await general.axios
      .post("/v3/user/trade/getTradeList", data)
      .finally(() => {
        Dialog.close();
      })
      .then((res) => {
        let {
          status,
          data: { account_list, paginated },
        } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }
        if (parms.page) {
          setPage(parms.page);
        }
        setTrades((trades) =>
          parms.page === 1 || !parms.page
            ? account_list
            : [...trades, ...account_list]
        );
        setMore(paginated.more && account_list.length > 0);
        setInit(true);
      })
      .catch((err) => {
        Dialog.error("getTradeList " + err.message);
      });
  });

  // 首次加载
  useEffect(() => {
    if (props.active && !init) {
      load({ page: 1 });
    }
  }, [props.active]);

  // kw 变化时重新加载数据
  useUpdateEffect(() => {
    if (props.active && init) {
      window.scrollTo(0, 0);
      load({ page: 1, kw });
    }
  }, [kw]);

  const scroll = useScroll();
  useUpdateEffect(() => {
    if (props.active && init) {
      if (scroll?.top < -80) {
        load({ page: 1 });
      }
      if (
        scroll?.top + window.innerHeight + 20 >= $(document).height() &&
        more
      ) {
        load({ page: page + 1 });
      }
    }
  }, [scroll, props.active, init]);

  return (
    <>
      <div className="trade-bar width">
        <div className="container">
          <div className="input">
            <Link
              to={`/trade/search?keyword=${kw}`}
              style={{ display: "flex", alignItems: "center", flex: 1 }}
            >
              <img
                className="icon"
                src="/resources/four-three/trade/search.png"
                alt=""
              />

              <input
                type="text"
                placeholder="请输入游戏名称"
                value={kw}
                readOnly
              />
            </Link>

            {kw ? (
              <CloseOutlined
                className="close"
                onClick={() => {
                  setKw("");
                  setQuery({ keyword: "" });
                }}
              />
            ) : null}
          </div>

          <div
            className="sort"
            onClick={() => {
              document.body.style.overflow = "hidden";

              Dialog.intro(
                "小号筛选",
                <FilterContent
                  initialFilter={filter}
                  onConfirm={(newFilter) => {
                    setFilter(newFilter);
                    window.scrollTo(0, 0);
                    load({ page: 1, filter: newFilter });
                  }}
                />,
                () => {
                  document.body.style.overflow = "auto";
                }
              );
            }}
            ref={sortRef}
          >
            {sorts[filter.sort].text}
            <img
              className="icon"
              src="/resources/four-three/trade/down.png"
              alt=""
            />
          </div>
        </div>
      </div>

      {init && trades.length > 0 && (
        <>
          <div className="trade-list">
            {trades.map((trade) => (
              <Link
                key={trade.trade_id}
                to={"/trade/detail?id=" + trade.trade_id}
                className="item"
              >
                <div className="item-top">
                  <div className="item-top-left">
                    <div className="item-game-name">
                      {trade.game_name_main || trade.game_name}
                      {trade.game_name_branch ? (
                        <div className="item-game-name-branch">
                          {trade.game_name_branch}
                        </div>
                      ) : null}
                    </div>
                    <div className="item-game-title">{trade.title}</div>
                    <div className="item-game-device">
                      <span className="server-name">
                        区服：{trade.server_name}
                      </span>
                      <span>实际充值：{trade.total_amount}元</span>
                    </div>
                  </div>
                  <div className="item-top-right">¥{trade.trade_price}</div>
                </div>

                <div className="item-pics">
                  {trade?.pic_list?.slice(0, 3).map((item, index) => (
                    <object key={index}>
                      <Link
                        to={
                          "/img?imgs=" +
                          trade?.pic_list +
                          "&img=" +
                          index +
                          "&tradeId=" +
                          trade.trade_id
                        }
                        className="bannerImg"
                      >
                        <Image src={item} alt="" />
                      </Link>
                    </object>
                  ))}
                </div>
              </Link>
            ))}
          </div>

          {trades.length > 0 && !more ? (
            <div className="view-end">别撩啦！已经到底啦~</div>
          ) : null}
        </>
      )}
      {init && trades.length === 0 && (
        <div
          style={{
            textAlign: "center",
            paddingTop: "10vh",
          }}
        >
          <img style={{ width: "50%" }} src="/resources/empty.png" alt="" />
          <p>暂无对应数据~</p>
        </div>
      )}
    </>
  );
};
